module.exports = __webpack_public_path__ + "static/media/business-development.9d86c3ae.svg";